var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn/content.controller copy 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1148.000000, -1014.000000)",
    id: "btn/content.controller-copy-11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1148.000000, 1014.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.8,
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 10.000000)",
    stroke: "#F1BF70",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/content.previous"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    transform: "translate(13.666667, 12.333333) scale(-1, 1) translate(-13.666667, -12.333333) ",
    points: "18.3333333 3 9 12.3333333 18.3333333 21.6666667"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRight);
export default __webpack_public_path__ + "static/media/carouselRight.2b372cfaf1448180cb85e03294f7698c.svg";
export { ForwardRef as ReactComponent };